interface ShortenStringParams {
    inputString: string | null | undefined;
    maxLength: number;
}

export default function shortenString({inputString, maxLength}: ShortenStringParams): string {
    if(inputString === null || inputString === undefined) return ""
    
    if (inputString.length <= maxLength) {
        return inputString;
    } else {
        return inputString.substring(0, maxLength) + '...';
    }
}
